<div class="row">
  <div class="col-lg col-md col-xs col-xl col-sm w-100">
    <mat-card class="mat-elevation-z8 w-100">
      <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
        <div class="row">
          <div class="col-lg col-md col-xs col-xl col-sm">
            <p class="tituloLeft">{{step}}</p>
          </div>
          <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
            <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
              *ngIf="!collapseCard"></i>
            <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
              *ngIf="collapseCard"></i>
          </div>
        </div>
        <mat-card-content *ngIf="!collapseCard">

          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Liberação da Receita Data</mat-label>
                <input matInput id="txtLibRecData" #txtLibRecData maxlength="10" mask="d0/M0/0000"
                  formControlName="liberacao_receita_data">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">
                  {{hintDate}}</mat-hint>
                <mat-hint align="end">{{txtLibRecData.value.length}} / 10</mat-hint>
                <mat-error>
                  {{hasErrorFormControl(formulario.controls.liberacao_receita_data)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Liberação da Receita Hora</mat-label>
                <input matInput id="txtLibRecHora" #txtLibRecHora maxlength="5" mask="Hh:m0"
                  formControlName="liberacao_receita_hora">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">
                  {{hintHour}}</mat-hint>
                <mat-hint align="end">{{txtLibRecHora.value.length}} / 5</mat-hint>
                <mat-error>
                  {{hasErrorFormControl(formulario.controls.liberacao_receita_hora)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Início do Tratamento Data</mat-label>
                <input matInput id="txtIniTratData" #txtIniTratData maxlength="10" mask="d0/M0/0000"
                  [dropSpecialCharacters]="false" formControlName="inicio_tratamento_data" (blur)="makeCalculations()">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">
                  {{hintDate}}</mat-hint>
                <mat-hint align="end">{{txtIniTratData.value.length}} / 10</mat-hint>
                <mat-error>
                  {{hasErrorFormControl(formulario.controls.inicio_tratamento_data)}}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Início do Tratamento Hora</mat-label>
                <input matInput id="txtIniTratHora" #txtIniTratHora maxlength="5" mask="Hh:m0"
                  [dropSpecialCharacters]="false" formControlName="inicio_tratamento_hora" (blur)="makeCalculations()">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">
                  {{hintHour}}</mat-hint>
                <mat-hint align="end">{{txtIniTratHora.value.length}} / 5</mat-hint>
                <mat-error>
                  {{hasErrorFormControl(formulario.controls.inicio_tratamento_hora)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Término do Tratamento Data</mat-label>
                <input matInput id="txtTermTratData" #txtTermTratData maxlength="10" mask="d0/M0/0000"
                  [dropSpecialCharacters]="false" formControlName="termino_tratamento_data" (blur)="makeCalculations()">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">
                  {{hintDate}}</mat-hint>
                <mat-hint align="end">{{txtTermTratData.value.length}} / 10</mat-hint>
                <mat-error>
                  {{hasErrorFormControl(formulario.controls.termino_tratamento_data)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Término do Tratamento Hora</mat-label>
                <input matInput id="txtTermTratHora" #txtTermTratHora maxlength="5" mask="Hh:m0"
                  [dropSpecialCharacters]="false" formControlName="termino_tratamento_hora" (blur)="makeCalculations()">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">
                  {{hintHour}}</mat-hint>
                <mat-hint align="end">{{txtTermTratHora.value.length}} / 5</mat-hint>
                <mat-error>
                  {{hasErrorFormControl(formulario.controls.termino_tratamento_hora)}}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Linha Tratamento</mat-label>
                <mat-select #txtSite formControlName="linha_tratamento" disableCenteringOption>
                  <input matInput type="text" class="form-control filterTxt" placeholder="Pesquisar por..."
                    (keyup)="createFilterLinhaTratamento($event.target.value)">
                  <mat-option *ngFor="let item of listLinhaTratamento" [value]="item.name">
                    {{item.name | uppercase}}
                  </mat-option>
                </mat-select>
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.linha_tratamento)}}</mat-error>
              </mat-form-field>
            </div>
            <div *ngIf="hasSuspendedList" class="col-lg col-md">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                    floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Nº da Tulha / Silo do Tratamento (Destino)</mat-label>
                    <mat-select multiple (selectionChange)="selectionChange()" #txtSite formControlName="silo_tratamento" disableCenteringOption>
                        <input matInput type="text" class= "form-control filterTxt"
                            placeholder="Pesquisar por..."
                            (keyup)="createFilterTulhaOuSiloDestino($event.target.value)">
                        <mat-option *ngFor="let item of listTulhaOuSiloDestino" [value]="item.name">
                            {{item.name | uppercase}}
                        </mat-option>
                    </mat-select>
                    <i matSuffix class="{{iconEnableField}}"></i>
                    <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                    <mat-error>{{hasErrorFormControl(formulario.controls.silo_tratamento)}}
                    </mat-error>
                </mat-form-field>
            </div>
            <div *ngIf="!hasSuspendedList" class="col-lg col-md">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                    floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Nº da Tulha / Silo do Tratamento (Destino)
                    </mat-label>
                    <input matInput id="txtNTulhaSiloTratDest" #txtNTulhaSiloTratDest maxlength="30"
                        formControlName="silo_tratamento">
                    <i matSuffix class="{{iconEnableField}}"></i>
                    <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                    <mat-hint align="end">{{txtNTulhaSiloTratDest.value.length}} / 30</mat-hint>
                    <mat-error>{{hasErrorFormControl(formulario.controls.silo_tratamento)}}
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Velocidade do Bowl (%)</mat-label>
                <input matInput id="txtVelBowlPrc" #txtVelBowlPrc maxlength="3" formControlName="velocidade_bowl_prc">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                <mat-hint align="end">{{txtVelBowlPrc.value.length}} / 3</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.velocidade_bowl_prc)}}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row pt-3">
            <!-- <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Tempo de Descarga "Início" (Tela Receita CBT, em
                                    Segundos)</mat-label>
                                <input matInput id="txtTmpDescIni" #txtTmpDescIni maxlength="2"
                                    formControlName="tempo_descarga_inicio" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 0 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                                <mat-hint align="end">{{txtTmpDescIni.value.length}} / 2</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.tempo_descarga_inicio)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Tempo de Descarga "Duração" (Tela Receita CBT, em
                                    Segundos)</mat-label>
                                <input matInput id="txtTmpDescDur" #txtTmpDescDur maxlength="2"
                                    formControlName="tempo_descarga_duracao" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 0 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                                <mat-hint align="end">{{txtTmpDescDur.value.length}} / 2</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.tempo_descarga_duracao)}}
                                </mat-error>
                            </mat-form-field>
                        </div> -->
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Batelada (kg)</mat-label>
                <input matInput id="txtBatelada" #txtBatelada maxlength="10" formControlName="batelada" currencyMask
                  [options]="{ thousands: '.', decimal: ',', precision: 0 }">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                <mat-hint align="end">{{txtBatelada.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.batelada)}}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Peso Total do Lote Tratado (kg)</mat-label>
                <input matInput id="txtPesoTotalLoteTratado" #txtPesoTotalLoteTratado maxlength="10"
                  formControlName="peso_total_lote_tratado" currencyMask
                  [options]="{ thousands: '.', decimal: ',', precision: 0 }" (blur)="makeCalculations()"
                  (blur)="makeCalculationsII()">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                <mat-hint align="end">{{txtPesoTotalLoteTratado.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.peso_total_lote_tratado)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Peso de Impressão Após Tratamento</mat-label>
                <input matInput id="txtPesoImpTrat" #txtPesoImpTrat maxlength="10"
                  formControlName="peso_impressao_apos_tratamento" currencyMask
                  [options]="{ thousands: '.', decimal: ',', precision: 2 }" (blur)="makeCalculations()"
                  class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                <mat-hint align="end">{{txtPesoImpTrat.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.peso_impressao_apos_tratamento)}}
                </mat-error>
              </mat-form-field>
            </div>
            <!-- <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Responsável Tratamento</mat-label>
                                <input matInput id="txtRespTratamento" #txtRespTratamento maxlength="80"
                                    formControlName="resp_tratamento">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-hint align="end">{{txtRespTratamento.value.length}} / 80</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.resp_tratamento)}}
                                </mat-error>
                            </mat-form-field>
                        </div> -->
          </div>

          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Velocidade da Esteira (Hz ou %)</mat-label>
                <input matInput id="txtVelEsteira" #txtVelEsteira maxlength="4" formControlName="velocidade_esteira"
                  currencyMask>
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                <mat-hint align="end">{{txtVelEsteira.value.length}} / 4</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.velocidade_esteira)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Unidade Medida Velocidade da Esteira</mat-label>
                <mat-select #txtUnidMedVelEsteira formControlName="unidade_medida_vel_esteira" disableCenteringOption>
                  <input matInput type="text" class="form-control filterTxt" placeholder="Pesquisar por..."
                    (keyup)="createFilterUnidadeMedidaVelEsteira($event.target.value)">
                  <mat-option *ngFor="let item of listUnidadeMedidaVelEsteira" [value]="item.name">
                    {{item.name | uppercase}}
                  </mat-option>
                </mat-select>
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.unidade_medida_vel_esteira)}}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Temperatura (ºC)
                </mat-label>
                <input matInput id="txtTemperatura" #txtTemperatura maxlength="4" formControlName="temperatura"
                  currencyMask [options]="{ thousands: '.', decimal: ',', precision: 1 }">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                <mat-hint align="end">{{txtTemperatura.value.length}} / 4</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.temperatura)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Lote FNG</mat-label>
                <input matInput id="txtLoteFng" #txtLoteFng maxlength="20" formControlName="lote_fng" readonly
                  class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtLoteFng.value.length}} / 20</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.lote_fng)}}</mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row pt-3">
            <!-- <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Lote FNG</mat-label>
                                <input matInput id="txtLoteFng" #txtLoteFng maxlength="10" formControlName="lote_fng">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-hint align="end">{{txtLoteFng.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.lote_fng)}}
                                </mat-error>
                            </mat-form-field>
                        </div> -->
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Observação</mat-label>
                <textarea matInput id="txtObs" #txtObs maxlength="255" formControlName="observacao"></textarea>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <mat-hint align="end">{{txtObs.value.length}} / 255</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.observacao)}}</mat-error>
              </mat-form-field>
            </div>
          </div>
        </mat-card-content>
      </form>
    </mat-card>
  </div>
</div>